export default function getUrlParams(url) {
  let match;
  const results = {};
  const pattern = /(\?|&)([^=]+)=([^&]+)/g;

  do {
    match = pattern.exec(url);
    if (match) {
      results[match[2]] = match[3];
    }
  } while (match);

  return results;
}
